import { toast } from '@gitbook/spine-react';

import { apiClient } from '../../state';

/**
 * Request a review for a change request.
 */
export async function requestReviewersForChangeRequest(props: {
    spaceId: string;
    changeRequestId: string;
    users: string[];
}) {
    const { spaceId, changeRequestId, users } = props;

    await toast.catch(async () => {
        await apiClient.changeRequestReviewers.requestReviewersForChangeRequest(
            spaceId,
            changeRequestId,
            {
                users,
            }
        );

        toast.success(
            `Review requested, ${
                users.length === 1
                    ? 'the reviewer will be notified.'
                    : 'the reviewers will be notified.'
            }`
        );
    }, 'Error while requesting reviewers');
}
